// Initialize Alpine.js

import Alpine from 'alpinejs'

import hash from './plugin.hash.js'
Alpine.plugin(hash)

import breakpoints from './plugin.breakpoints.js'
Alpine.plugin(breakpoints)

import bodyClass from './plugin.body-class.js'
Alpine.plugin(bodyClass)

import focus from '@alpinejs/focus'
Alpine.plugin(focus)

import intersect from '@alpinejs/intersect'
Alpine.plugin(intersect)

import { resize } from '@alpinejs/resize'
Alpine.plugin(resize);

import './data.transition.js'

window.Alpine = Alpine
